import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><g fillRule="evenodd"><path d="M3 4h14v1H3zM3 9h14v1H3zM3 14h10v1H3zM20 4v11.252c-.773-.377-1.884-.341-2.94.178-1.572.773-2.427 2.327-1.908 3.47.518 1.144 2.214 1.444 3.787.67 1.28-.629 2.085-1.776 2.06-2.797V4h-1z" /></g></svg>);